module.exports = __webpack_public_path__ + "static/gynosphinx-4ffb7b79d4d5e7ccd0e0c18464832284.jpeg";